import { render, staticRenderFns } from "./LeftBarShipping.vue?vue&type=template&id=2e5d934a&"
import script from "./LeftBarShipping.vue?vue&type=script&lang=js&"
export * from "./LeftBarShipping.vue?vue&type=script&lang=js&"
import style0 from "./LeftBarShipping.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports